import { css } from '@linaria/core';
import { COLORS, typographyStyles } from '@livecommerce/design-system';

const { getBodyText } = typographyStyles;

const WIDTH = 280;

export const toggle = css`
  position: absolute;
  z-index: 10;
  background-color: ${COLORS.black};
  color: ${COLORS.white};
  ${getBodyText(12)}
  transform: rotate(90deg);
  bottom: 369px;
  left: -49px;
  padding: 8px;
  border-radius: 8px 8px 0px 0px;
  border: 0;
  transition: transform 0.2s ease-in-out;

  &:hover {
    background-color: ${COLORS.blackLight};
  }

  &.open {
    transform: rotate(90deg) translateY(-${WIDTH}px);
  }
`;

export const container = css`
  width: ${WIDTH}px;
  height: 250px;
  background-color: ${COLORS.black};
  position: absolute;
  z-index: 10;
  bottom: 300px;
  left: -${WIDTH}px;
  color: ${COLORS.white};
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease-in-out;
  ${getBodyText(12)}
  &.open {
    transform: translateX(${WIDTH}px);
  }
`;

export const content = css`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  height: 100%;
`;

export const element = css`
  padding: 4px;
`;

export const tabs = css`
  display: flex;
`;

export const tab = css`
  background-color: ${COLORS.black};
  color: ${COLORS.white};
  ${getBodyText(12)}
`;

export const search = css`
  margin: 8px;
  padding: 4px;
`;
